// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

export const AnalyticsIcon = (props: IconProps) => (
  <svg viewBox="0 0 216 216" {...props}>
    <g>
      <path
        fill="currentColor"
        d="M122.1,0h-9.4v103.3H216v-9.4C216,42.1,173.9,0,122.1,0z M131.5,84.5V19.4c33.9,4.2,60.9,31.2,65.1,65.1
        H131.5z"
      />
      <path
        fill="currentColor"
        d="M103.3,28.2h-9.4C42.1,28.2,0,70.3,0,122.1C0,173.9,42.1,216,93.9,216c51.8,0,93.9-42.1,93.9-93.9v-9.4
        h-84.5V28.2z M168.5,131.5c-4.6,37-36.3,65.7-74.5,65.7c-41.4,0-75.1-33.7-75.1-75.1c0-38.2,28.7-69.9,65.7-74.5v83.9H168.5z"
      />
    </g>
  </svg>
);

export const ReviewsIcon = (props: IconProps) => (
  <svg viewBox="0 0 360 360" {...props}>
    <g>
      <defs>
        <path
          id="SVGID_1_"
          d="M179.4,10L179.4,10c-12.9,0-23.7,8.2-27.4,20.5l-27.4,86.9H31.7c-12.4,0-23.7,8.2-27.4,19.7
			c-3.7,11.8,0.5,24.7,10.3,32.1l74.2,54.2l-27.4,86.3c-3.7,11.8,0.5,24.7,10.8,32.1c4.7,3.7,10.8,5.3,16.6,5.3
			c5.8,0,11.8-1.6,17.1-5.3l73.4-54.2l72.4,53.7c5.3,3.7,11.3,5.8,17.1,5.8c5.8,0,11.8-1.6,16.6-5.3c10.3-7.6,14.5-20.5,10.8-32.1
			l-27.4-86.3l74.2-54.2c10.3-7.6,14.5-20.5,10.3-32.1c-3.7-11.8-15-19.7-27.4-19.7h-90.8l-28.4-86.9C202.8,17.9,191.8,10,179.4,10z
			 M179.4,39l35,107.4H326L235.2,213l34,105.8l-89.8-66.6l-90.8,66.6L122.3,213l-90.8-66.6h113.7L179.4,39z"
        />
      </defs>
      <use
        xlinkHref="#SVGID_1_"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <rect
        x="-94.8"
        y="-87.8"
        clipPath="url(#SVGID_2_)"
        fill="currentColor"
        width="547.6"
        height="532.8"
      />
    </g>
  </svg>
);

export const QAIcon = (props: IconProps) => (
  <svg viewBox="0 0 360 360" {...props}>
    <g>
      <defs>
        <path
          id="QSVGID_1_"
          d="M208.3,214.4c-9.2-6.9-18.9-12.2-29.1-15.6l-8.6,17.6c6.5,2.3,12.8,5.5,19.1,9.6c-4,1.5-8.2,2.2-12.6,2.2
			c-11.9,0-21.8-4.4-29.6-13.3c-7.8-8.9-11.7-22.2-11.7-40.1c0-17.6,3.9-30.7,11.7-39.5c7.8-8.8,18-13.1,30.6-13.1
			c12.6,0,22.8,4.4,30.5,13.1c7.8,8.7,11.7,21.9,11.7,39.5c0,8.5-1,16.1-3,22.7C215.2,204.2,212.2,209.8,208.3,214.4z M233.1,231.8
			c6.1-7.2,10.6-14.6,13.3-22.2c3.7-10,5.5-21.6,5.5-34.8c0-24.9-6.6-44.3-19.9-58.2c-13.3-13.9-31.2-20.8-53.9-20.8
			c-22.9,0-41,6.9-54.3,20.8c-13.3,13.9-20,33.3-20,58.2c0,25,6.7,44.4,20,58.3c13.3,13.8,31.7,20.7,55.2,20.7
			c12.2,0,23.2-2.2,33.2-6.6c12.7,8.5,19.6,13.1,20.5,13.5c4.4,2.4,9,4.3,13.7,5.7l11.4-21.8C248.9,241.6,240.7,237.3,233.1,231.8z
			 M179.5,350C84.8,350,8,273.2,8,178.5S84.8,7,179.5,7S351,83.8,351,178.5S274.2,350,179.5,350z"
        />
      </defs>
      <use
        xlinkHref="#QSVGID_1_"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
      <clipPath id="QSVGID_2_">
        <use xlinkHref="#QSVGID_1_" overflow="visible" />
      </clipPath>
      <rect
        x="-82.3"
        y="-83.3"
        clipPath="url(#QSVGID_2_)"
        fill="currentColor"
        width="523.5"
        height="523.5"
      />
    </g>
  </svg>
);

export const ContentIcon = (props: IconProps) => (
  <svg viewBox="36 -24 146 176" /* 0 0 216 146 */ {...props}>
    <path
      fill="currentColor"
      d="M164.3,34.8c-1.3-1.3-3-2-4.9-2h-36.1V9.9c0-1.6-0.6-2.9-1.7-4.1c-1.1-1.1-2.5-1.7-4.1-1.7H79.3
	c-1.6,0-3.3,0.4-5.3,1.2c-1.9,0.8-3.4,1.8-4.5,2.9L50.9,26.9c-1.1,1.1-2.1,2.6-2.9,4.5s-1.2,3.7-1.2,5.3v53.5c0,1.6,0.6,2.9,1.7,4.1
	c1.1,1.1,2.5,1.7,4.1,1.7h21.7v40.4c0,1.9,0.7,3.5,2,4.9c1.3,1.3,3,2,4.9,2h78.2c1.9,0,3.5-0.7,4.9-2c1.3-1.3,2-3,2-4.9V39.7
	C166.3,37.8,165.6,36.2,164.3,34.8z M56.3,32.3L75,13.6c0.5-0.5,1.3-0.9,2.4-1.3v22.4H55C55.4,33.6,55.8,32.8,56.3,32.3z M54.5,88.3
	V42.4h24.8c1.6,0,2.9-0.6,4.1-1.7c1.1-1.1,1.7-2.5,1.7-4.1V11.8h30.6v21h-2.3c-1.9,0-4,0.5-6.3,1.4c-2.3,1-4.1,2.1-5.5,3.5
	L79.2,60.1c-1.3,1.3-2.5,3.2-3.5,5.5c-1,2.3-1.4,4.4-1.4,6.3v16.3H54.5z M111.1,42.6v27h-27c0.5-1.4,1-2.4,1.6-2.9l22.5-22.5
	C108.7,43.6,109.7,43.1,111.1,42.6z M157.1,134H83.5V78.8h29.9c1.9,0,3.5-0.7,4.9-2c1.3-1.3,2-3,2-4.9V42h36.8V134z"
    />
  </svg>
);

export const AccountIcon = (props: IconProps) => (
  <svg viewBox="26 -20 166 166" /* 0 0 216 146 */ {...props}>
    <g>
      <path
        fill="currentColor"
        d="M124.9,102.2c0-0.5-0.2-1.1-0.6-1.6c-3-3.6-5.5-6.8-7.3-9.4c1.1-2.2,2-4.3,2.6-6.2l12.6-2
		c0.5-0.1,0.9-0.3,1.3-0.9c0.4-0.5,0.6-1,0.6-1.6V65.5c0-0.6-0.2-1.1-0.6-1.6s-0.8-0.7-1.4-0.9l-12.4-1.9c-0.6-1.8-1.5-4.1-2.8-6.7
		c0.8-1.2,2-2.8,3.7-4.9c1.6-2.1,2.8-3.5,3.4-4.4c0.4-0.5,0.6-1.1,0.6-1.5c0-1.5-3.9-5.8-11.7-13c-0.5-0.4-1.1-0.7-1.7-0.7
		c-0.7,0-1.2,0.2-1.6,0.6l-9.6,7.3c-2.2-1.1-4.3-2-6.1-2.5l-1.9-12.5c-0.1-0.5-0.3-1-0.8-1.4c-0.5-0.4-1-0.6-1.6-0.6H74.4
		c-1.2,0-2.1,0.7-2.4,2c-0.7,2.5-1.3,6.7-1.9,12.5c-2.3,0.8-4.4,1.6-6.3,2.6l-9.4-7.3c-0.5-0.4-1.1-0.6-1.7-0.6
		c-1,0-3.2,1.6-6.4,4.8c-3.3,3.2-5.5,5.6-6.7,7.3c-0.4,0.4-0.6,1-0.6,1.6c0,0.5,0.2,1,0.6,1.6c3,3.6,5.5,6.8,7.3,9.4
		c-1.1,2.2-2,4.3-2.6,6.2l-12.6,2c-0.5,0.1-0.9,0.3-1.3,0.9c-0.4,0.5-0.6,1-0.6,1.6v15.1c0,0.6,0.2,1.1,0.6,1.6
		c0.4,0.5,0.8,0.7,1.4,0.8l12.4,2c0.7,2.1,1.6,4.3,2.9,6.7c-0.9,1.2-2.1,2.9-3.8,5c-1.7,2.1-2.8,3.6-3.3,4.3
		c-0.4,0.5-0.6,1.1-0.6,1.5c0,1.5,3.9,5.8,11.7,13c0.5,0.4,1.1,0.7,1.7,0.7c0.7,0,1.2-0.2,1.6-0.6l9.6-7.3c2.2,1.1,4.3,2,6.1,2.5
		l1.9,12.5c0.1,0.5,0.3,1,0.8,1.4c0.5,0.4,1,0.6,1.6,0.6h15.2c1.2,0,2.1-0.7,2.4-2c0.7-2.6,1.3-6.8,1.9-12.6
		c2.2-0.7,4.3-1.5,6.3-2.5l9.4,7.3c0.5,0.4,1.1,0.6,1.7,0.6c1,0,3.2-1.6,6.4-4.8c3.2-3.2,5.5-5.7,6.7-7.3
		C124.7,103.4,124.9,102.9,124.9,102.2z M96.7,87.7c-4.1,4.1-9,6.1-14.7,6.1c-5.8,0-10.7-2-14.7-6.1c-4.1-4.1-6.1-9-6.1-14.7
		c0-5.8,2-10.7,6.1-14.7c4.1-4.1,9-6.1,14.7-6.1c5.8,0,10.7,2,14.7,6.1c4.1,4.1,6.1,9,6.1,14.7C102.8,78.7,100.7,83.6,96.7,87.7z"
      />
      <path
        fill="currentColor"
        d="M174.1,106.4c-0.7-1.6-1.5-3-2.4-4.2c2.8-6.1,4.2-9.9,4.2-11.2c0-0.2-0.1-0.4-0.3-0.6
		c-6.5-3.8-9.9-5.7-10.1-5.7l-0.5,0.2c-2.2,2.2-4.7,5.3-7.5,9.1c-1.1-0.1-1.9-0.2-2.4-0.2c-0.5,0-1.4,0.1-2.4,0.2
		c-0.8-1.1-2.2-3-4.2-5.5s-3.3-3.8-3.7-3.8c-0.1,0-0.9,0.4-2.4,1.3c-1.5,0.9-3.1,1.8-4.8,2.8c-1.7,1-2.6,1.5-2.9,1.6
		c-0.2,0.2-0.3,0.4-0.3,0.6c0,1.4,1.4,5.1,4.2,11.2c-0.9,1.2-1.7,2.7-2.4,4.2c-8.1,0.8-12.1,1.7-12.1,2.5v11.4c0,0.9,4,1.7,12.1,2.5
		c0.6,1.5,1.5,2.9,2.4,4.2c-2.8,6.1-4.2,9.9-4.2,11.2c0,0.2,0.1,0.4,0.3,0.6c6.6,3.9,10,5.8,10.1,5.8c0.4,0,1.7-1.3,3.7-3.8
		c2.1-2.6,3.5-4.4,4.2-5.5c1.1,0.1,1.9,0.2,2.4,0.2c0.5,0,1.4-0.1,2.4-0.2c0.8,1.1,2.2,3,4.2,5.5c2.1,2.6,3.3,3.8,3.7,3.8
		c0.1,0,3.5-1.9,10.1-5.8c0.2-0.2,0.3-0.4,0.3-0.6c0-1.4-1.4-5.1-4.2-11.2c1-1.4,1.8-2.8,2.4-4.2c8.1-0.8,12.1-1.7,12.1-2.5V109
		C186.2,108.1,182.2,107.3,174.1,106.4z M162.3,122c-2,2-4.5,3.1-7.4,3.1s-5.3-1-7.4-3.1c-2-2-3.1-4.5-3.1-7.4c0-2.8,1-5.3,3.1-7.3
		s4.5-3.1,7.3-3.1s5.3,1,7.3,3.1c2.1,2.1,3.1,4.5,3.1,7.3C165.4,117.6,164.3,120,162.3,122z"
      />
      <path
        fill="currentColor"
        d="M174.1,23c-0.7-1.6-1.5-3-2.4-4.2c2.8-6.1,4.2-9.9,4.2-11.2c0-0.2-0.1-0.4-0.3-0.6
		c-6.5-3.8-9.9-5.7-10.1-5.7l-0.5,0.2c-2.2,2.2-4.7,5.3-7.5,9.1c-1.1-0.1-1.9-0.2-2.4-0.2c-0.5,0-1.4,0.1-2.4,0.2
		c-0.8-1.1-2.2-3-4.2-5.5c-2.1-2.5-3.3-3.8-3.7-3.8c-0.1,0-0.9,0.4-2.4,1.3s-3.1,1.8-4.8,2.8c-1.7,1-2.6,1.5-2.9,1.6
		c-0.2,0.2-0.3,0.4-0.3,0.6c0,1.4,1.4,5.1,4.2,11.2c-0.9,1.2-1.7,2.7-2.4,4.2c-8.1,0.8-12.1,1.7-12.1,2.5v11.4c0,0.9,4,1.7,12.1,2.5
		c0.6,1.5,1.5,2.9,2.4,4.2c-2.8,6.1-4.2,9.9-4.2,11.2c0,0.2,0.1,0.4,0.3,0.6c6.6,3.9,10,5.8,10.1,5.8c0.4,0,1.7-1.3,3.7-3.8
		c2.1-2.6,3.5-4.4,4.2-5.5c1.1,0.1,1.9,0.2,2.4,0.2c0.5,0,1.4-0.1,2.4-0.2c0.8,1.1,2.2,3,4.2,5.5c2.1,2.6,3.3,3.8,3.7,3.8
		c0.1,0,3.5-1.9,10.1-5.8c0.2-0.2,0.3-0.4,0.3-0.6c0-1.4-1.4-5.1-4.2-11.2c1-1.4,1.8-2.8,2.4-4.2c8.1-0.8,12.1-1.7,12.1-2.5V25.5
		C186.2,24.7,182.2,23.8,174.1,23z M162.3,38.6c-2,2-4.5,3.1-7.4,3.1s-5.3-1-7.4-3.1c-2-2-3.1-4.5-3.1-7.4c0-2.8,1-5.3,3.1-7.3
		s4.5-3.1,7.3-3.1s5.3,1,7.3,3.1c2.1,2.1,3.1,4.5,3.1,7.3C165.4,34.1,164.3,36.6,162.3,38.6z"
      />
    </g>
  </svg>
);

export const SupportIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 228.081 228.081"
    {...props}
  >
    <path
      fill="currentColor"
      d="M220.581 71.027h-63.527V7.501c0-4.142-3.358-7.5-7.5-7.5H78.526c-4.142 0-7.5 3.358-7.5 7.5v63.526H7.5c-4.142 0-7.5 3.358-7.5 7.5v71.032c0 4.142 3.358 7.5 7.5 7.5h63.526v63.521c0 4.142 3.358 7.5 7.5 7.5h71.027c4.142 0 7.5-3.358 7.5-7.5v-63.521h63.527c4.142 0 7.5-3.358 7.5-7.5V78.527c.001-4.142-3.357-7.5-7.499-7.5zm-7.5 71.032h-63.527c-4.142 0-7.5 3.358-7.5 7.5v63.521H86.026v-63.521c0-4.142-3.358-7.5-7.5-7.5H15V86.027h63.526c4.142 0 7.5-3.358 7.5-7.5V15.001h56.027v63.526c0 4.142 3.358 7.5 7.5 7.5h63.527v56.032z"
    />
  </svg>
);

export const AdminIcon = (props: IconProps) => (
  <svg viewBox="0 0 216 216" {...props}>
    <g>
      <path
        fill="currentColor"
        d="M214.8,88.7c-1.2-1.2-1.2-1.2-2.4-1.2L187,83.9c-1.2-3.6-3.6-8.4-6-13.3c1.2-2.4,4.8-6,7.2-9.7
        c3.6-4.8,6-7.2,7.2-9.7c1.2-1.2,1.2-2.4,1.2-3.6c0-3.6-8.4-12.1-24.1-26.5c-1.2-1.2-2.4-1.2-3.6-1.2c-1.2,0-2.4,0-3.6,1.2L146,35.6
        c-4.8-2.4-8.4-3.6-13.3-4.8l-3.6-25.3c0-1.2-1.2-2.4-1.2-2.4c-1.2-1.2-2.4-1.2-3.6-1.2H92.9c-2.4,0-4.8,1.2-4.8,3.6
        c-1.2,4.8-2.4,13.3-4.8,25.3c-4.8,1.2-8.4,3.6-12.1,4.8L50.7,21.1c0-1.2-1.2-1.2-2.4-1.2c-2.4,0-6,3.6-13.3,9.7S22.9,41.6,20.5,44
        c-1.2,1.2-1.2,2.4-1.2,3.6c0,1.2,0,2.4,1.2,3.6c6,7.2,10.9,13.3,15.7,19.3c-2.4,4.8-4.8,8.4-6,13.3L3.6,87.5
        c-1.2,0-2.4,1.2-2.4,1.2C0,89.9,0,91.1,0,92.3v31.4c0,1.2,0,2.4,1.2,3.6s1.2,1.2,2.4,1.2l26.5,3.6c1.2,4.8,3.6,8.4,6,13.3
        c-1.2,2.4-4.8,6-8.4,10.9c-3.6,4.8-6,7.2-7.2,8.4c-1.2,1.2-1.2,2.4-1.2,3.6c0,3.6,8.4,12.1,24.1,26.5c1.2,1.2,2.4,1.2,3.6,1.2
        c1.2,0,2.4,0,3.6-1.2l20.5-14.5c4.8,2.4,8.4,3.6,13.3,4.8l3.6,25.3c0,1.2,1.2,2.4,1.2,2.4c1.2,1.2,2.4,1.2,3.6,1.2h31.4
        c2.4,0,4.8-1.2,4.8-3.6c1.2-4.8,2.4-14.5,3.6-26.5c4.8-1.2,8.4-3.6,13.3-4.8l19.3,15.7c1.2,1.2,2.4,1.2,3.6,1.2
        c2.4,0,6-3.6,13.3-9.7c7.2-7.2,10.9-12.1,14.5-14.5c1.2-1.2,1.2-2.4,1.2-3.6c0-1.2,0-2.4-1.2-3.6c-6-7.2-10.9-14.5-15.7-19.3
        c2.4-4.8,3.6-8.4,4.8-13.3l26.5-3.6c1.2,0,2.4-1.2,2.4-1.2c1.2-1.2,1.2-2.4,1.2-3.6V92.3C216,91.1,216,89.9,214.8,88.7z
        M138.8,138.2c-8.4,8.4-19.3,12.1-30.2,12.1c-12.1,0-21.7-3.6-30.2-12.1c-8.4-8.4-13.3-18.1-13.3-30.2S70,86.3,78.4,77.8
        s19.3-12.1,30.2-12.1c12.1,0,21.7,3.6,30.2,12.1c8.4,8.4,13.3,18.1,13.3,30.2S147.2,129.7,138.8,138.2z"
      />
    </g>
  </svg>
);

export const SocialCollectionIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 432 432"
    {...props}
  >
    <defs>
      <path
        id="social-collection-a"
        d="M267.3 95.5l24.7 48.2h115v197.9H26V143.7h114.9l24.7-48.2h101.7zm0-24.7H165.7c-9.3 0-17.8 5.2-22 13.4L125.8 119H26c-13.7 0-24.7 11.1-24.7 24.7v197.9c0 13.7 11.1 24.7 24.7 24.7h381c13.7 0 24.7-11.1 24.7-24.7V143.7c0-13.7-11.1-24.7-24.7-24.7h-99.8l-17.8-34.8c-4.3-8.2-12.8-13.4-22.1-13.4z"
      />
    </defs>
    <use
      xlinkHref="#social-collection-a"
      overflow="visible"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <clipPath id="social-collection-b">
      <use xlinkHref="#social-collection-a" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#social-collection-b)"
      fill="currentColor"
      d="M-75.9-6.4H509v450H-75.9z"
    />
    <g>
      <defs>
        <path
          id="social-collection-c"
          d="M217.4 286.9c30.6 0 55.4-24.8 55.4-55.4 0-30.6-24.8-55.4-55.4-55.4S162 200.9 162 231.5c0 30.6 24.8 55.4 55.4 55.4zm0 22.2c-42.9 0-77.6-34.7-77.6-77.6s34.7-77.6 77.6-77.6 77.6 34.7 77.6 77.6-34.7 77.6-77.6 77.6z"
        />
      </defs>
      <use
        xlinkHref="#social-collection-c"
        overflow="visible"
        fill="currentColor"
      />
      <clipPath id="social-collection-d">
        <use xlinkHref="#social-collection-c" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#social-collection-d)"
        fill="currentColor"
        d="M62.6 76.7h309.6v309.6H62.6z"
      />
    </g>
    <g>
      <defs>
        <path
          id="social-collection-e"
          d="M97.8 104.9H51.6c-6.4 0-11.5-5.2-11.5-11.5 0-6.4 5.2-11.5 11.5-11.5h46.2c6.4 0 11.5 5.2 11.5 11.5 0 6.4-5.1 11.5-11.5 11.5z"
        />
      </defs>
      <use
        xlinkHref="#social-collection-e"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
      <clipPath id="social-collection-f">
        <use xlinkHref="#social-collection-e" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#social-collection-f)"
        fill="currentColor"
        d="M-37.1 4.7h223.7v177.5H-37.1z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Nav.js